import { registerPlugin } from '@capacitor/core';
const CapacitorSafeArea = registerPlugin('CapacitorSafeArea', {
    web: () => import('./web').then(m => new m.CapacitorSafeAreaWeb()),
});
export * from './definitions';
export { CapacitorSafeArea };
//# sourceMappingURL=index.js.map